<template>
    <section class="section">
        <h3 class="title is-3">Подтвердите пользователей</h3>

        <b-tabs type="is-boxed" v-model="tab">
            <b-tab-item label="На рассмотрение" icon="account-clock-outline" :value="STATUS_IN_REVIEW" ></b-tab-item>
            <b-tab-item label="Подтвержденные" icon="check-decagram" :value="STATUS_APPROVED"></b-tab-item>
            <b-tab-item label="Отклоненные" icon="cancel" :value="STATUS_DECLINED"></b-tab-item>
        </b-tabs>

        <b-table
            :data="applicationsList"

            :per-page="options.perPage"
            :current-page.sync="options.currentPage"
            :pagination-simple="false"
            pagination-position="bottom"
            default-sort-direction="asc"
            sort-icon="chevron-up"
            sort-icon-size="is-small"
            :loading="isApplicationLoading"

            :backend-filtering="true"
            :backend-sorting="true"
            :backend-pagination="true"
            @filters-change="filterChange"
            @sort="sortChange"
            :total="paginator.total"
            paginated
            striped
            narrowed
            hoverable
            focusable
            ref="table"
            :default-sort="options.sortBy"
            :default-sort-direction="options.sortDirection"
            aria-next-label="Следующая страница"
            aria-previous-label="Предыдущая страница"
            aria-page-label="Страница"
            aria-current-label="Текущая страница"
        >
            <b-table-column field="user.lastName" label="Фамилия"  sortable searchable>
                <template #searchable="props">
                    <b-input
                        v-model="props.filters[props.column.field]"
                        placeholder="Search..."
                        icon="magnify"
                        size="is-small" />
                </template>
                <template v-slot="props">
                    {{ props.row.user.lastName }}
                </template>
            </b-table-column>
            <b-table-column field="user.firstName" label="Имя"  sortable searchable>
                <template #searchable="props">
                    <b-input
                        v-model="props.filters[props.column.field]"
                        placeholder="Search..."
                        icon="magnify"
                        size="is-small" />
                </template>
                <template v-slot="props">
                    {{ props.row.user.firstName }}
                </template>
            </b-table-column>

            <b-table-column field="user.surName" label="Отчество"  sortable searchable>
                <template #searchable="props">
                    <b-input
                        v-model="props.filters[props.column.field]"
                        placeholder="Search..."
                        icon="magnify"
                        size="is-small" />
                </template>
                <template v-slot="props">
                    {{ props.row.user.surName }}
                </template>
            </b-table-column>

            <b-table-column v-if="currentUser.isAdmin" field="cpoId" label="Организация" searchable sortable>
                <template #searchable="props">
                    <b-select v-model="props.filters[props.column.field]" size="is-small" style="max-width: 100px">
                        <option :value="null">Все</option>
                        <option v-for="item in allOrganizationList" :title="item.parentPath()" :value="item.id">{{item.name}}</option>
                    </b-select>
                </template>
                <template v-slot="props">
                    <span :title="organizationsFullPathByUserRoles(props.row.userRolePivot, organizationId)">{{ organizationNamesByUserRoles(props.row.userRolePivot, organizationId) }}</span>
                </template>
            </b-table-column>

            <b-table-column field="roleId" label="Роль"  sortable searchable>
                <template #searchable="props">
                    <b-select v-model="props.filters[props.column.field]" size="is-small">
                        <option :value="null">Все</option>
                        <option v-for="role in rolesList" :value="role.id">{{role.name}}</option>
                    </b-select>
                </template>
                <template v-slot="props">
                    {{ roleNamesByUserRoles(props.row.userRolePivot, organizationId) }}
                </template>
            </b-table-column>

            <b-table-column  field="positionId" :visible="tab === STATUS_APPROVED" label="Должность" searchable sortable>
                <template #searchable="props">
                    <b-select v-model="props.filters[props.column.field]" size="is-small" style="max-width: 140px">
                        <option :value="null">Все</option>
                        <option v-for="position in positionList" :title="position.fullname" :value="position.id">{{position.name}}</option>
                    </b-select>
                </template>
                <template v-slot="props">
                    <span :title="positionNamesByUserRoles(props.row.userRolePivot, organizationId)">{{ positionNamesByUserRoles(props.row.userRolePivot, organizationId) }}</span>
                </template>
            </b-table-column>

            <b-table-column  field="groupId" :visible="tab === STATUS_APPROVED"  label="Группа" searchable sortable>
                <template #searchable="props">
                    <b-select v-model="props.filters[props.column.field]" size="is-small" style="max-width: 140px">
                        <option :value="null">Все</option>
                        <option v-for="group in groupList" :value="group.id">{{group.name}}</option>
                    </b-select>
                </template>
                <template v-slot="props">
                    <span>{{ groupNamesByUserRoles(props.row.userRolePivot, organizationId) }}</span>
                </template>
            </b-table-column>

            <b-table-column field="createdAt" label="Дата">
                <template v-slot="props">
                    <b-tag type="is-info is-light">{{ $_get(props.row, 'createdAt') | datetime }}</b-tag>
                </template>
            </b-table-column>

            <b-table-column field="status" label="Статус" >
                <template v-slot="props">
                    {{ props.row.status | appStatusToText }}
                </template>
            </b-table-column>

            <b-table-column field="action" label="" v-slot="props" width="50px">
                <div class="buttons">
                    <b-button v-if="props.row.status === STATUS_IN_REVIEW" title="Подтвердить" @click="selectedApplicationId = props.row.id" icon-right="check-decagram" type="is-success" size="is-small" />
                    <b-button v-if="props.row.status !== STATUS_DECLINED" title="Отклонить" @click="declineApplication(props.row)"  icon-right="delete" type="is-danger" size="is-small" />
                </div>
            </b-table-column>

            <template #bottom-left>
                <b>Общее количество</b>: {{ paginator.total }}
            </template>

            <template #empty>
                <div class="has-text-centered">Больше нет новых заявок</div>
            </template>
        </b-table>

        <application-modal :application-id.sync="selectedApplicationId" />
    </section>
</template>
<script>


import { mapActions, mapGetters } from 'vuex'
import {
    get,
    map,
    cloneDeep,
    reduce,
    includes,
    merge,
} from 'lodash'
import { STATUS_APPROVED, STATUS_DECLINED, STATUS_IN_REVIEW } from '../../../store/models/applications/model'
import { ADMIN } from '../../../store/models/roles/model'
import { NULL_UID } from '../../../constants'

import PaginatedFetchMixin from '../../../mixins/PaginatedFetchMixin'
import UserRolesMixin from '../../../mixins/UserRolesMixin'
import ApplicationMixin from '../../../mixins/ApplicationMixin'
import ApplicationModal from './Index/ApplicationModal'
import { TYPE_CPO } from '../../../store/models/organizations/model'
import ContextMixin from '../../../mixins/ContextMixin'
import OrganizationFetchMixin from '../../../mixins/OrganizationFetchMixin'

export default {
    mixins: [
        PaginatedFetchMixin,
        UserRolesMixin,
        ApplicationMixin,
        ContextMixin,
        OrganizationFetchMixin,
    ],
    components: {
        ApplicationModal,
    },
    created () {
        if (!this.currentUser.isAdmin) {
            this.organizationId = this.userOrganizationId
        }
    },
    mounted() {
        this.fetchRoles()
        this.fetchOrganizationsIfNeeded()
        this.fetchGroups()
        this.fetchDebounce()
    },
    computed: {
        ...mapGetters({
            currentUser: 'e/users/currentUser',
            isLoaderActive: 'e/pages/isLoaderActive',
            findOrganization: 'e/organizations/find',
            userOrganizationId: 'e/users/currentOrganizationId',

            applicationsQuery: 'e/applications/query',
            rolesQuery: 'e/roles/query',
            groupQuery: 'e/groups/query',
            positionQuery: 'e/positions/query',
            organizationQuery: 'e/organizations/query',
        }),
        statusByTab() {
            return this.tab
        },
        isApplicationLoading() {
            return this.isLoaderActive('applications.fetchItems')
        },
        applicationsList () {
            return this.applicationsQuery()
            .with('user.userRolePivot.role')
            .where('status', this.statusByTab)
            .where(application => {
                return includes(this.paginator.ids, application.id)
            })
            .get()
        },
        rolesList() {
            return this.rolesQuery().where('sysname', item => item !== ADMIN).get()
        },
        positionList() {
            let query = this.positionQuery().orderBy('name').where('parentId', value => !!value)
            return reduce(
                query.findIn(this.positionIds),
                (result, item) => {
                    result.push(item)
                    return result
                },
                [{id: NULL_UID, 'name': 'Без должности'}]
            )
        },
        groupList() {
            let curOrgId
            if (this.currentUser.isAdmin) {
                curOrgId = this.filters['cpoId'] ? this.filters['cpoId'] : null
            } else {
                curOrgId = this.organizationId
            }

            let groupQuery = this.groupQuery().whereHasNot('children')
            if (curOrgId) {
                groupQuery = groupQuery.where('cpoId', curOrgId)
            }
            return reduce(
                groupQuery.get(),
                (result, item) => {
                    result.push(item)
                    return result
                },
                [{id: NULL_UID, 'name': 'Без группы'}]
            )
        },
        allOrganizationList() {
            return this.organizationQuery().where('type', TYPE_CPO).orderBy('name').get()
        },
    },

    methods: {
        ...mapActions({
            fetchItems: 'e/applications/fetchItems',
            fetchApplication: 'e/applications/fetchById',
            fetchGroups: 'e/groups/fetchItems',
            fetchPositions: 'e/positions/fetchItems',
            fetchOrganizations: 'e/organizations/fetchItems',
            approve: 'e/applications/approve',
            decline: 'e/applications/decline',
            fetchRoles: 'e/roles/fetchItems',
        }),
        filterFieldMap(key, default_ = null) {
            let map = {
                'user.firstName': 'FirstName',
                'user.surName': 'SurName',
                'user.lastName': 'LastName',
                'positionId': 'PositionId',
                'groupId': 'GroupId',
                'roleId': 'RoleId',
                'cpoId': 'cpoId',
            }
            return get(map, key, default_)
        },
        customFilter(filters) {
            let options = cloneDeep(this.options)
            options.sortBy = this.filterFieldMap(options.sortBy, 'createdAt')
            let _filter = {}
            for (let i in this.filters) {
                let key = this.filterFieldMap(i)
                if (key && this.filters[i]) {
                    _filter[key] = this.filters[i]
                }
            }
            return merge({Status: this.statusByTab}, options, _filter, filters)
        },

        getPositions() {
            this.fetchPositions({
                CpoId: this.organizationId,
                ApplicationStatus: this.statusByTab
            }).then((data)=>{
                this.positionIds = map(data.data, 'id')
            })
        },

        contextChangedHandler() {
            this.organizationId = !this.currentUser.isAdmin ? this.userOrganizationId : null
            this.fetchDebounce()
            this.getPositions()
        }
    },
    data() {
        return {
            tab: STATUS_IN_REVIEW,
            selectedApplicationId: null,
            position: null,
            group: null,

            organizationId: null,
            positionIds: [],

            STATUS_IN_REVIEW,
            STATUS_APPROVED,
            STATUS_DECLINED,
        }
    },
    watch: {
        tab (val) {
            this.options.currentPage = 1;
            if (this.isSetFilter) {
                this.filters = {}
                this.$refs.table.filters = {}
            } else {
                this.fetchDebounce()
            }

            if (val === STATUS_APPROVED) {
                this.getPositions()
            }
        },
    }
}
</script>